module.exports = __webpack_public_path__ + "static/img/device-s2.464f2bd8.png";